'use strict';

var chunkERLKLNQZ_js = require('./chunk-ERLKLNQZ.js');
var chunkJHFKSNYO_js = require('./chunk-JHFKSNYO.js');

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function p(i){return chunkJHFKSNYO_js.a(i)?["$merge","$ignoreUndefined"].some(a=>a in i):!1}function h(...i){if(i.length<2)throw new Error("deepMerge\u51FD\u6570\u81F3\u5C11\u9700\u8981\u4E24\u4E2A\u53C2\u6570");let a=i.length>0?p(i[i.length-1]):!1,{$merge:d,$ignoreUndefined:f,skipKeys:u}=chunkERLKLNQZ_js.c({skipKeys:[],$ignoreUndefined:!0,$merge:"replace"},a?i[i.length-1]:{});function l(t,e){chunkJHFKSNYO_js.a(t)&&Object.entries(t).forEach(([n,r])=>{let g;n in e?Array.isArray(r)&&Array.isArray(e[n])?(d==="replace"?g=r:d==="append"?g=[...e[n],...r]:d==="append"?g=[...new Set([...e[n],...r])]:typeof d=="function"&&(g=d(e[n],r,{key:n,from:t,to:e})),e[n]=f&&r===void 0?e[n]:g):chunkJHFKSNYO_js.a(r)&&chunkJHFKSNYO_js.a(e[n])?l(r,e[n]):e[n]=f&&r===void 0?e[n]:r:e[n]=r;});}return i.reduce((t,e,n)=>n==0?t||{}:(!chunkJHFKSNYO_js.a(e)||a&&n===i.length-1||l(e,t||{}),t),i[0])}

exports.a = h;
